import { BookingPaymentTermsRow } from 'cb-model';

export const getBookingPaymentTermsText = (row: BookingPaymentTermsRow) =>
  row.text
    .replace(/CANX_ALLOWED_HOURS_BEFORE_START/g, String(row.canx_allowed_hours_before_start ?? 0))
    .replace(/CANX_ALLOWED_DAYS_BEFORE_START/g, String((row.canx_allowed_hours_before_start ?? 0) / 24));
